import React from "react"
import { List } from "flowbite-react"
const CommonProblemSolved = ({ data }) => {
  return (
    <div className="md:px-20 h-full md:pe-10 bg-white-200 xl:pe-20 px-6 flex flex-col pt-12 md:pt-[2.75rem] ">
      <div className="items-center w-max  basis-full flex gap-32 md:gap-8 flex-row">
        <div className="flex  self-start w-[390px] md:w-[480px] xl:w-[597px] flex-col gap-4 md:gap-10 ">
          <div className="flex flex-col gap-3 md:gap-4 w-full">
            <div className="flex items-center gap-2">
              <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
              <h4
                className={`text-gray-500 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4%`}
              >
                About
              </h4>
            </div>
            <h2
              className={`text-gray-100 text-3xl md:text-5xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
            >
              Problem we solved
            </h2>
            <div className="my-4 text-[1.08rem] md:text-[1.125rem] text-black-300  ">
              {data.description}
            </div>

            {!!data.challenges.length && (
              <>
                <h4 className="text-black-300 text-2xl">Major Challenges</h4>
                <List
                  theme={{
                    root: {
                      base: "marker:text-blue-100 marker:text-xl space-y-1 text-gray-500 dark:text-gray-400 ml-4 md:w-9/12",
                      ordered: {
                        off: "list-disc text-[24px] text-blue-100",
                      },
                    },
                  }}
                  className=" text-black-300 text-[1.08rem]  leading-tight md:text-sm"
                >
                  {data.challenges.map((list, index) => (
                    <List.Item className="!my-0" key={index}>
                      {list}
                    </List.Item>
                  ))}
                </List>
              </>
            )}
          </div>
        </div>
        <div className="self-end w-[260px] md:min-w-[430px] xl:min-w-[700px]  relative h-full  ">
          {data.image}
          <div className="absolute rounded-t-[999px] z-0 w-[245px] md:w-[320px] xl:w-[439px] bottom-0 mx-auto top-[30%] md:top-[60%] xl:top-2/4 left-0 right-0  bg-primary-100"></div>
        </div>
      </div>
    </div>
  )
}

export default CommonProblemSolved
